module.exports = __webpack_public_path__ + "static/media/planning3@2x.ee16cd9d.png";